(function() {
'use strict'

AppTabs.createTab( {

name: 'db-management',
icon: 'database',
text: 'DB Management',
create: function(init) {
	init.setController( new TabControllerVue({
		el: '#v-db-management',
		methods : {
			resetData() {
				this.fetching                    = false;
				this.db_name                     = null;
				this.table_count                 = null;
				this.db_size                     = null;
				this.migration_table_names       = null;
				this.migration_table_count       = 0;
				this.db_restructure_info         = null;
				this.db_restructure_started      = null;
				this.db_restructure_completed    = null;
				this.db_restructure_elapsed      = null;
				this.db_initialization_info      = null;
				this.db_initialization_started   = null;
				this.db_initialization_completed = null;
				this.db_initialization_elapsed   = null;
				this.db_migration_info           = null;
				this.db_migration_started        = null;
				this.db_migration_completed      = null;
				this.db_migration_elapsed        = null;
			},
			loadInfo() {
				this.fetching = true;
				const _this = this;
				window.ajaxCall({
					data : {
						action: 'db_summary_info',
					},
					onSuccess : function({ data }) {
						_this.db_name = data.db_name;
						_this.table_count = data.table_count;
						_this.db_size = data.db_size;
						_this.migration_table_names = data.migration_table_names;
						_this.migration_table_count = data.migration_table_names;
						_this.db_restructure_info = data.db_restructure_info;
						_this.db_restructure_started = data.db_restructure_started;
						_this.db_restructure_completed = data.db_restructure_completed;
						_this.db_restructure_elapsed = data.db_restructure_elapsed;
						_this.db_initialization_info = data.db_initialization_info;
						_this.db_initialization_started = data.db_initialization_started;
						_this.db_initialization_completed = data.db_initialization_completed;
						_this.db_initialization_elapsed = data.db_initialization_elapsed;
						_this.db_migration_info = data.db_migration_info;
						_this.db_migration_started = data.db_migration_started;
						_this.db_migration_completed = data.db_migration_completed;
						_this.db_migration_elapsed = data.db_migration_elapsed;
					},
					onError : function( response ) {
						alert( 'Could not load DB info.' );
					},
					onComplete : function() {
						_this.fetching = false;
					},
				});
				this.$refs.migration.loadInfo();
			},
			onShowTab() {
				this.loadInfo();
			},
		}
	}) );

}

})

})();
